import { Component, Input, Output, EventEmitter, OnDestroy, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { Globals } from 'src/app/shared/globals/globals';
import { AdUserForGrid, AdUsers } from 'src/app/shared/models/data/adUsers.model';
import { AuthorizationInfo } from 'src/app/shared/models/data/authInfo.model';
import { Groups } from 'src/app/shared/models/data/groups.model';
import { UserToSave } from 'src/app/shared/models/data/users.model';
import { BackendService } from 'src/app/shared/services/backend/backend.service';
import { TeiasoftLoaderService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-loader.service';
import { TeiasoftBreadCrumb } from 'src/app/shared/teiasoft-bucket/teiasoft-breadcrumb/teiasoft-breadcrumb.component';
import { SelectOption } from 'src/app/shared/teiasoft-bucket/teiasoft-select/teiasoft-select.component';

export class CreateUserSteps {
  action?: string;
  parameter?: any;
  isActive?: boolean;
  disabled?: boolean;
}

@Component({
  selector: 'app-modal-user',
  templateUrl: './modal-user.component.html',
  styleUrls: ['./modal-user.component.scss']
})
export class ModalUserComponent implements OnInit, OnDestroy, OnChanges {
  @Input() isMobile: boolean = false;
  @Input() theme: string = 'silver';
  @Input() action: string = 'create';
  @Input() authInfo: AuthorizationInfo = new AuthorizationInfo();
  @Input() groups: Groups = new Groups();
  @Input() userName: string = "";

  @Output() closeModalUser: EventEmitter<any> = new EventEmitter();

  topPx: number = 0;
  userInAd: string = "";
  buttonSearchAdDisabled: boolean = true;
  subscriptions: Subscription = new Subscription();
  adUsers: AdUsers = new AdUsers();
  columnsToHide: string[] = new Array();
  minWidthVw: number = 50;
  isLoadedAdUsers: boolean = false;
  adUsersForGrid: AdUserForGrid[] = new Array();
  createUserSteps: CreateUserSteps[] = new Array();
  userSelected: string = "";
  officeSelectedId: number | null = null;
  millSelectedId: number | null = null;
  selectedStepIndex: number = 0;
  officeOptionList: SelectOption[] = new Array();
  selectOfficeDisabled: boolean = true;
  groupsOptionList: SelectOption[] = new Array();
  millsOptionList: SelectOption[] = new Array();
  groupsList: any[] = new Array();
  userToSave: UserToSave = new UserToSave();
  oldGroupsOptionList: SelectOption[] = new Array();
  clearValue: boolean = false;
  selectedRow: any;
  sapEmployeeNumberDisabled: boolean = false;

  constructor(private teiasoftLoader: TeiasoftLoaderService, private backendService: BackendService,
    public globals: Globals) {
    this.topPx = window.scrollY;
    this.createSteps();
  }

  ngOnInit(): void {
    if (this.action == 'create') {
      this.userToSave = new UserToSave();
      this.sapEmployeeNumberDisabled = false;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes["action"]) {
      this.action = changes["action"].currentValue;
      if (this.action == 'create') this.sapEmployeeNumberDisabled = false;
    }

    if (changes && changes["userName"]) {
      this.userName = changes["userName"].currentValue;
      if (this.userName != '') {
        this.getUserByUsername();
      }
    }

    if (changes && changes["authInfo"]) {
      this.authInfo = new AuthorizationInfo();
      this.authInfo = changes["authInfo"].currentValue;
      this.fillAuthInfoandMillsOptionsList();
    }

    if (changes && changes["groups"]) {
      this.groups = new Groups();
      this.groups = changes["groups"].currentValue;
      this.fillGroupsOptionList();
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  createSteps() {
    this.createUserSteps = new Array();
    let _item: CreateUserSteps = new CreateUserSteps();
    _item.action = 'selectUserFromAD';
    _item.disabled = false;
    _item.isActive = true;
    _item.parameter = '';
    this.createUserSteps.push(_item);

    _item = new CreateUserSteps();
    _item.action = 'createUser';
    _item.disabled = true;
    _item.isActive = false;
    _item.parameter = "";
    this.createUserSteps.push(_item);
  }

  searchInAd() {
    this.teiasoftLoader.start();
    this.subscriptions.add(
      this.backendService.searchInAd(this.userInAd).subscribe(res => {
        this.teiasoftLoader.stop();
        this.adUsers = new AdUsers();
        this.adUsers = res;
        this.adUsersForGrid = new Array();
        // Set Office
        for (var x = 0; x < this.adUsers.adUsers!.length; x++) {
          let _item: AdUserForGrid = new AdUserForGrid();
          let _office: string = "";
          _item.adUsername = this.adUsers.adUsers![x].adUsername;

          if (this.adUsers.adUsers![x].adOfficeId != null) {
            if (this.authInfo.offices!.filter(k => k.officeId == this.adUsers.adUsers![x].adOfficeId)[0])
              _office = this.authInfo.offices!.filter(k => k.officeId == this.adUsers.adUsers![x].adOfficeId)[0].officeCode!;
          }
          _item.adOffice = _office;
          this.adUsersForGrid.push(_item);
        }
        this.adUsersForGrid = this.adUsersForGrid.sort((a, b) => (a.adUsername!.toLowerCase() > b.adUsername!.toLowerCase()) ? 1 : ((b.adUsername!.toLowerCase() > a.adUsername!.toLowerCase() ? -1 : 0)));
        this.isLoadedAdUsers = true;
      }));
  }

  fillAuthInfoandMillsOptionsList() {
    const emptyOption = new SelectOption();
    emptyOption.text = '';
    emptyOption.value = null;

    this.officeOptionList = new Array();
    this.officeOptionList.push(emptyOption);
    for (var x = 0; x < this.authInfo.offices!.length; x++) {
      let _item: SelectOption = new SelectOption();
      _item.text = this.authInfo.offices![x].officeCode!;
      _item.value = this.authInfo.offices![x].officeId!;
      this.officeOptionList.push(_item);
    }

    this.millsOptionList = new Array();
    this.millsOptionList.push(emptyOption);
    for (var x = 0; x < this.authInfo.mills!.length; x++) {
      let _item: SelectOption = new SelectOption();
      _item.text = this.authInfo.mills![x].shortName!;
      _item.value = this.authInfo.mills![x].millId!;
      this.millsOptionList.push(_item);
    }
  }

  fillGroupsOptionList() {
    this.groupsOptionList = new Array();
    for (var x = 0; x < this.groups.groups!.length; x++) {
      let _item: SelectOption = new SelectOption();
      _item.text = this.groups.groups![x].groupName!;
      _item.value = this.groups.groups![x].groupId!;
      this.groupsOptionList.push(_item);
    }

    this.groupsOptionList.sort((a, b) => (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0));
    this.oldGroupsOptionList = new Array();
    this.oldGroupsOptionList = JSON.parse(JSON.stringify(this.groupsOptionList));
  }

  isDisabledSave(): boolean {
    if (!this.userToSave) return true;
    if (!this.userToSave.groupsId || this.userToSave.groupsId?.length == 0) return true;
    //if (this.userToSave.millId == null) return true;
    //if (this.userToSave.officeId == null) return true;
    if (this.userToSave.username == '') return true;
    return false;
  }

  saveUser() {
    this.teiasoftLoader.start();
    if (this.action == 'create') {
      this.subscriptions.add(this.backendService.createUser(this.userToSave).subscribe(res => {
        this.teiasoftLoader.stop();
        this.closeModalUser.emit('reload');
      }));
    } else {
      let _userToSave: UserToSave = new UserToSave();
      _userToSave = JSON.parse(JSON.stringify(this.userToSave));
      delete _userToSave.username;
      this.subscriptions.add(this.backendService.updateUser(_userToSave, this.userToSave.username!).subscribe(res => {
        this.teiasoftLoader.stop();
        this.closeModalUser.emit('reload');
      }));
    }

  }

  getUserByUsername() {
    this.teiasoftLoader.start();
    this.subscriptions.add(this.backendService.getUsers(this.userName).subscribe(res => {
      this.teiasoftLoader.stop();
      this.userToSave = new UserToSave;
      this.userToSave.groupsId = new Array();
      this.userToSave.groupsId = JSON.parse(JSON.stringify(res.users![0].groupsId));
      this.userToSave.millId = res.users![0].defaultMillId;
      this.userToSave.officeId = res.users![0].defaultOfficeId;
      this.userToSave.username = res.users![0].username;
      this.userToSave.sapEmployeeNumber = res.users![0].sapEmployeeNumber ?? null;
      this.selectOfficeDisabled = !res.users![0].isDefaultOfficeEditable!;
      this.sapEmployeeNumberDisabled = !res.users![0].isSapEmployeeNumberEditable!;

      // Internal var
      this.userSelected = this.userName;
      this.officeSelectedId = res.users![0].defaultOfficeId!;
      this.millSelectedId = res.users![0].defaultMillId!;
      this.groupsList = new Array();
      for (var x = 0; x < res.users![0].groupsId!.length; x++) {
        this.groupsList.push(this.groupsOptionList.filter(g => g.value == res.users![0].groupsId![x])[0].text);
        this.groupsOptionList = this.groupsOptionList.filter(v => v.value != res.users![0].groupsId![x]);
      }
    }));
  }

  /* EVENTS */
  onSaveUserClick() {
    this.saveUser();
  }

  onCloseModalClick() {
    this.closeModalUser.emit('');
  }

  onInputUserInAd(evt: string) {
    if (evt.length < 2) {
      this.buttonSearchAdDisabled = true;
      return;
    }
    this.userInAd = evt;
    this.buttonSearchAdDisabled = false;
  }

  onSearchInAdClick() {
    this.selectOfficeDisabled = true;
    this.officeSelectedId = null;
    this.searchInAd();
  }

  rowClick(evt: any) {
    this.selectedRow = evt;
    this.userSelected = evt["adUsername"];
    if (evt["adOffice"] != '' && this.authInfo.offices!.filter(x => x.officeCode == evt["adOffice"])[0])
      this.officeSelectedId = this.authInfo.offices!.filter(x => x.officeCode == evt["adOffice"])[0].officeId!;
    else
      this.selectOfficeDisabled = false;

    this.selectedStepIndex = 1;
    this.userToSave.username = this.userSelected;
    this.userToSave.officeId = this.officeSelectedId != null ? this.officeSelectedId : undefined;
    this.createUserSteps[1].disabled = false;
  }

  tbcClick(evt: TeiasoftBreadCrumb) {
    this.selectedStepIndex = evt.newIndex!;
  }

  onSelectedOffice(evt: SelectOption) {
    this.officeSelectedId = evt.value == '' ? null : evt.value!
    this.userToSave.officeId = this.officeSelectedId!;
  }

  onSelectedMill(evt: SelectOption) {
    this.millSelectedId = evt.value == '' ? null : evt.value!
    this.userToSave.millId = this.millSelectedId!;
  }

  onSelectedGroup(evt: SelectOption) {
    if (!this.groupsList) this.groupsList = new Array();
    if (evt.text) {
      this.groupsList.push(evt.text);
      if (!this.userToSave.groupsId) this.userToSave.groupsId! = new Array();
      if (!this.userToSave.groupsId) this.userToSave.groupsId = new Array();
      this.userToSave.groupsId.push(evt.value);
      this.groupsOptionList = this.groupsOptionList.filter(x => x.value != evt.value);
      this.clearValue = true;
      setTimeout(() => this.clearValue = false, 250);
    }
  }

  onInputSapEmployeeNumber(evt: string) {
    this.userToSave.sapEmployeeNumber = evt == '' ? null : evt;
  }

  deleteValue(evt: any) {
    this.groupsList = this.groupsList.filter(x => x != evt);
    this.groupsOptionList.push(this.oldGroupsOptionList.filter(x => x.text == evt)[0]);
    this.groupsOptionList.sort((a, b) => (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0));

    this.userToSave.groupsId = new Array();
    for (var x = 0; x < this.groupsList.length; x++) {
      let _id: number = this.oldGroupsOptionList.filter(o => o.text == this.groupsList[x])[0].value;
      this.userToSave.groupsId.push(_id);
    }
  }

  onKeyDown(evt: any) {
    if (evt.key == 'Enter') {
      if (this.userInAd.length < 2) return;
      this.onSearchInAdClick();
    }
  }
}
